import { render, staticRenderFns } from "./MyAccreditationEvents.vue?vue&type=template&id=07df2605&scoped=true&"
import script from "./MyAccreditationEvents.vue?vue&type=script&lang=js&"
export * from "./MyAccreditationEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df2605",
  null
  
)

export default component.exports